import {
    PhoneNumberFormat,
    PhoneNumberUtil,
} from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const checkPhone = (phone, country) => {

    console.log({phone, country});
    

    const number = phoneUtil.parseAndKeepRawInput(phone, country);
    const typePhone = phoneUtil.getNumberType(number);
    const isPhoneValid = phoneUtil.isValidNumber(number);
    const isPhoneValidByRegion = phoneUtil.isValidNumberForRegion(number, country);
    let result = null;
    let indicativePhone = null;

    if (typePhone === 0) { // 0 - fijo | 1 - Celular.
        result = phoneUtil.format(number, PhoneNumberFormat.NATIONAL);
        const nationalNumber = phoneUtil.getNationalSignificantNumber(number);

        // Obtener la longitud del indicativo
        const indicativeLength = phoneUtil.getLengthOfGeographicalAreaCode(number);

        // Extraer el indicativo dinámicamente
        indicativePhone = indicativeLength > 0 ? nationalNumber.substring(0, indicativeLength) : null;
    } else {
        result = phoneUtil.format(number, PhoneNumberFormat.E164);
        indicativePhone = `+${number.getCountryCode()}`;
    }

    return {
        getNumber: result,
        isAllowed: isPhoneValid && isPhoneValidByRegion ? true : false,
        typePhone: typePhone === 0 ? 0 : 1,
        indicativePhone: indicativePhone
    }
}

export const maskPhone = (phone) => {
    const takeThreeFirstNumber = phone.slice(0, 3);
    const takeTwoLastNumber = phone.slice(-2);
    return `${takeThreeFirstNumber}*****${takeTwoLastNumber}`;
};